import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  mapMutations,
} from 'vuex';

export default {
  name: 'InputCompany',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    name: '',
    label: '',
    property: '',
    modelState: '',
    rules: '',
    disabled: false,
    placeholder: '',
    mask: '',
  },
  data: () => ({
    changed: false,
  }),
  computed: {
    model: {
      get() {
        return this.modelState;
      },
      set(newModel) {
        this.setCompany(newModel);
        return newModel;
      },
    },
    showMask() {
      return this.changed && (typeof this.mask !== 'undefined');
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setPersonalDataMutation: 'SET_PERSONALDATA',
      setCompany: 'SET_COMPANY',
    }),
    triggerChange() {
      this.changed = true;
    },
  },
};
